<template>
  <div class="home">
    <div class="home__content container">
      <Search class="home__content-search" />
      <Catalogs :homeData="homeData" />
      <AboutMalmarket />
      <Premium :homeData="homeData" />
      <Newest :homeData="homeData" />
      <FindOffice />
    </div>
  </div>
</template>

<script>
import Search from '@/components/home/Search'
import Catalogs from '@/components/home/Catalogs'
import Premium from '@/components/home/Premium'
import Newest from '@/components/home/Newest'
import FindOffice from '@/components/home/FindOffice'
import AboutMalmarket from '@/components/home/AboutMalmarket.vue'
import axios from 'axios'
export default {
  components: {
    Search,
    Catalogs,
    Premium,
    Newest,
    FindOffice,
    AboutMalmarket
  },
  data :() => ({
    homeData: null,
  }),
  created() {
    this.FETCH_HOME();
  },
  mounted(){

  },
  methods: {
    FETCH_HOME(){
      axios
        .get("home-page")
        .then((response) => {this.homeData = response.data})
        .catch((e) => {
          console.log(e);
          
        });
    
    }
  }
}
</script>
